import script from "./NewOrderModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./NewOrderModal.vue?vue&type=script&setup=true&lang=ts"

import "./NewOrderModal.vue?vue&type=style&index=0&id=76c9615d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-76c9615d"]])

export default __exports__